/**
 * Created by hitotright on 2019/4/12.
 */

let utils = {
    unique1: function (arr) {
        let hash = [];
        for (let i = 0; i < arr.length; i++) {
            if (hash.indexOf(arr[i]) === -1) {
                hash.push(arr[i]);
            }
        }
        return hash;
    },
    mult_arr_splice: function (arr,key_arr) {
        if (typeof(key_arr)!=='string'){
            for (let i = 0; i < arr.length; i++) {
                for(let j in arr[i]){
                    if(key_arr.indexOf(j) === -1) {
                       delete arr[i][j]
                    }
                }
            }
        }else{
            let tmp = []
            for (let i = 0; i < arr.length; i++) {
                for(let j in arr[i]){
                    if(key_arr.indexOf(j) !== -1) {
                        tmp.push(arr[i][j])
                    }
                }
            }
            arr = tmp;
        }
        return arr;
    }
}

export default utils;




// WEBPACK FOOTER //
// ./src/utils.js